<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">{{"COMMON.ADD" | translate}} Multi Duplicate</h5>
        <div class="edit-icons" (click)="onCancel()">
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content d-flex flex-column justify-content-center m-h">
        <form action="" [formGroup]="addForm" (ngSubmit)="onSubmit()">
            <div class="mt-3">
                <input  type="text" class="form-control" id="" cols="10" rows="4" formControlName="duplicate"
                    placeholder="Enter Duplicate">
                <mat-error *ngIf="isControlHasError('msg','required')"> {{"This is required"|translate}}</mat-error>
            </div>
        </form>
    </div>
    <div class="row">
        <div class="col-md-6 m-auto">
            <button mat-raised-button color="primary" class="auth-form-btn mt-3 mt-lg-4" type="submit"
                (click)="onSubmit()">{{ "Save" | translate }}</button>
        </div>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>